<template>
  <q-layout view="lHh Lpr lFf">
    <q-header bordered>
      <q-toolbar>
        <q-toolbar-title>
          <router-link :to="{ path: '/' }"><t-logo-type style="max-width: 300px" /></router-link
        ></q-toolbar-title>
        <header-menu />
      </q-toolbar>
    </q-header>

    <q-drawer v-model="leftDrawerOpen" show-if-above bordered>
      <router-link :to="{ path: '/' }">
        <t-logo class="q-ml-md q-mt-sm" style="max-width: 100px" />
      </router-link>
      <q-list>
        <q-item-label header> Quick Links </q-item-label>
        <header-list />
      </q-list>
    </q-drawer>

    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script setup>
import { ref } from 'vue'
import HeaderList from 'src/components/header/HeaderList.vue'
import HeaderMenu from 'src/components/header/HeaderMenu.vue'
import TLogo from 'src/components/logo/TLogo.vue'
import TLogoType from 'src/components/logo/TLogoType.vue'

const leftDrawerOpen = ref(false)
</script>
